/**
 * @generated SignedSource<<3e2ddf280c39b6dac53b6d0e776abc62>>
 * @relayHash a786d9d0e61f197760e4ba332ddd07c6
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID a786d9d0e61f197760e4ba332ddd07c6

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Proposition",
    "kind": "LinkedField",
    "name": "proposition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfContracts",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RelatedContractStepQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RelatedContractStepQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a786d9d0e61f197760e4ba332ddd07c6",
    "metadata": {},
    "name": "RelatedContractStepQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "9c547cdaf4b381e9fb3a2f70a8b5b093";

export default node;
